import Vue from "vue";
import router from "./router";
import store from "./store/index.js";
import App from "./App.vue";

//date-fns
import { format } from "date-fns";
var caLocale = require("date-fns/locale/en");
//Fontawesome stuff
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";

//mapbox css
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";

//Progressbar
import VueProgressBar from "vue-progressbar";
const progressBarOpts = {
    color: "#1E965B",
    failedColor: "#961e1e",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300
    },
    autoRevert: true,
    location: "top",
    inverse: false
};
Vue.use(VueProgressBar, progressBarOpts);

//Notifications
import Notifications from "vue-notification";
Vue.use(Notifications);

//Font awesome
import {
    faBalanceScale,
    faBan,
    faCalendarAlt,
    faCheck,
    faChevronRight,
    faCogs,
    faCommentDots,
    faCut,
    faDrawPolygon,
    faFingerprint,
    faLeaf,
    faMapMarkedAlt,
    faRulerCombined,
    faShippingFast,
    faSnowplow,
    faUserShield,
    faFrown,
    faBars
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faBalanceScale,
    faBan,
    faCalendarAlt,
    faCheck,
    faChevronRight,
    faCogs,
    faCommentDots,
    faCut,
    faDrawPolygon,
    faFingerprint,
    faLeaf,
    faMapMarkedAlt,
    faRulerCombined,
    faShippingFast,
    faSnowplow,
    faUserShield,
    faFrown,
    faBars
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

//Vue select
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

//Vue multi-select
import vMultiSelect from "vue-multiselect";
Vue.component("vue-multiselect", vMultiSelect);
//Vue-mulotiselect css
import "vue-multiselect/dist/vue-multiselect.min.css";

//Vue select
import DatePicker from "vuejs-datepicker";
Vue.component("v-datepicker", DatePicker);

//Pretty-checkbox
import "pretty-checkbox/src/pretty-checkbox.scss";
import PrettyCheckBox from "pretty-checkbox-vue/check";
Vue.component("p-checkbox", PrettyCheckBox);

//Finally
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

Vue.prototype.$dateFns = {
    format: format,
    locale: caLocale
};
